module.exports = __webpack_public_path__ + "static/media/contact-bonn.9ae9a9f0.png";